import { Environment } from '../config/Environment'
import { startAnalytics } from 'payment-widget-core'

/**
 * Включение аналитики платёжной формы флагом REACT_APP_ANALYTICS_IS_ENABLED.
 *
 * Всё остальное — провайдер, события, дедупликация, маскирование PAN, а также
 * form_opened в момент старта — живёт в payment-widget-core. В vite-формах это
 * делает setupCore(); в CRA его нет, поэтому зовём startAnalytics() сами.
 * Пока аналитика не поднята, любой вызов formAnalytics — бесплатный no-op.
 *
 * Адрес отправки собираем здесь же и явно. По умолчанию ядро берёт базу из
 * `window.settings.env.APP_API_URL`, который публикует setupCore() — в CRA его
 * нет, база выходит пустой, и endpoint получился бы относительным
 * (`/v1/event`): события уходили бы на origin самой формы вместо API.
 *
 * Хвостовой слэш срезаем — REACT_APP_API_URL приходит из окружения деплоя и
 * иногда заканчивается на '/', а '//v1/event' это уже не тот путь.
 */
const rawApiUrl = String(Environment.REACT_APP_API_URL || '')
const apiUrl = rawApiUrl.endsWith('/') ? rawApiUrl.slice(0, -1) : rawApiUrl

startAnalytics({
  isEnabled: Environment.REACT_APP_ANALYTICS_IS_ENABLED,
  endpoint: Environment.REACT_APP_ANALYTICS_ENDPOINT
    || (apiUrl ? `${apiUrl}/v1/event` : undefined),
  // Пусто — ядро подставит дефолт бэкенда ('unsecure').
  signKey: Environment.REACT_APP_ANALYTICS_SIGN_KEY || undefined,
  batchSize: 1,
})

// form_left выключен ровно так же, как был до переезда в core: тело
// attachLeaveTracking() здесь было закомментировано целиком. Включается одной
// строкой, когда решим, что событие нужно:
//   import { attachLeaveTracking } from 'payment-widget-core'
//   attachLeaveTracking()
